import {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed';
import smoothScrollIntoViewDetails from './details-smooth-scroll-into-view';
import {appConfig} from '@stencil/hotels-config';
const {scrollIntoViewOptionsDetails: defaultScrollIntoViewOptions} = appConfig;

export const scrollIntoViewDetails = (
  node: Element | null,
  options?: Partial<SmoothBehaviorOptions>,
) => {
  if (!node) {
    return;
  }

  return smoothScrollIntoViewDetails(node, {
    ...(defaultScrollIntoViewOptions as SmoothBehaviorOptions),
    ...options,
  });
};

export const scrollToEl = (idOfElToScrollTo: string, options?: Partial<SmoothBehaviorOptions>) => {
  const elToScrollTo = document && document.querySelector(idOfElToScrollTo);
  if (!elToScrollTo) {
    return;
  }

  return scrollIntoViewDetails(elToScrollTo, options);
};
